/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { setStep03, resetQuotes, setStep03Renewals, getRenewalVariation, getQuoteVariation } from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step03 from '../../../components/pages/Quote/Step03w/Step03w'

const mapStateToProps = (state: RootState, props: any) => {
    let isWineSpiritsSteve = get(state, 'quote.checkStep.response.isWineSpiritsSteve', false)
    return {
        quote: state.quote,
        fullQuote: get(state.quote, 'full.response.quote', {}),
        isWineSpiritsSteve: isWineSpiritsSteve ? isWineSpiritsSteve : get(props, 'isWineSpiritsSteve', false),
    }
}

export default connect(
    mapStateToProps,
    {
        setStep03: setStep03,
        setStep03Renewals: setStep03Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        getQuoteVariation,
    }
)(Step03)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step03w.tsx